import React, { useEffect, useState } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { connect, useSelector } from 'react-redux'

import { redirectToDashboard } from 'helpers/miscellaneous'
import { _roomName } from 'store/selectors/Room'
import * as thunks from 'store/thunks/Feedback'

import message from './feedback.json'
import FeedbackForm from './FeedbackForm'
import FeedbackGif from './FeedbackGif'
import {
    FeedbackGifs,
    Container,
    FeedbackGifWrapper,
    MasonaryWrapper,
    TextCenter,
    Heading,
    Message,
    NextButton,
    NextButtonImage,
    GifSection,
    GifColumn,
    GifBox,
} from './styles'

const chevronRight = '/img/feedback/ChevronRight.svg'

const FeedbackNew = props => {
    const roomName = useSelector(_roomName)

    if (!roomName) redirectToDashboard()

    const [selectedGifs, setSelectedGifs] = useState([])
    const [isSubmitFeedbackScreen, setSubmitFeedbackScreen] = useState(false)
    const [verifiedSelection, setVerifiedSelection] = useState(false)
    const [showFeedback, setShowFeedback] = useState(false)
    const [feedbackMessage, setFeedbackMessage] = useState('')
    const [isBlinkMessage, setIsBlinkMessage] = useState(false)

    useEffect(() => {
        props.onGetFeedbackQuestion(roomName)
    }, [])

    const toggleSubmitFeedbackScreen = () => {
        const showFeedback = isSubmitFeedbackScreen ? true : false
        setSubmitFeedbackScreen(prevState => !prevState)
        setShowFeedback(showFeedback)
        setIsBlinkMessage(false)
    }

    const toggleBySameGif = (array, data) =>
        array.filter(item => {
            if (item.category === data.category) {
                if (item.response === data.response) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        })

    const addGif = data => {
        let selected = [...selectedGifs]
        let isBlink = false
        const isGifAlreadyExist =
            selectedGifs.findIndex(item => item.id === data.id) > -1
        const isGifSameCategory =
            selectedGifs.filter(item => item.category === data.category)
                .length > 0
        let shouldAutoSave = true
        if (isGifAlreadyExist) {
            selected = selectedGifs.filter(item => item.id !== data.id)
            setShowFeedback(false)
        } else {
            if (selected.length < 2) {
                selected = selectedGifs.concat(data)
                setShowFeedback(false)
                if (isGifSameCategory) {
                    setFeedbackMessage(message.warning.sameCategory)
                    setShowFeedback(true)
                    selected = toggleBySameGif(selected, data)
                }
            } else if (selected.length === 2 && isGifSameCategory) {
                selected = toggleBySameGif(selectedGifs.concat(data), data)
                setFeedbackMessage(message.warning.sameCategory)
                setShowFeedback(true)
            } else {
                setFeedbackMessage(message.warning.maxCap)
                shouldAutoSave = false
                setShowFeedback(true)
                isBlink = true
            }
        }
        setSelectedGifs(selected)
        if (shouldAutoSave) {
            const feedbackData = {
                feedback_question: props.feedbackQuestion.feedback_question,
                comments: '',
                room_name: roomName,
                gifs: selected.map(item => item.id),
            }
            props.onSubmitFeedback(feedbackData)
        }
        if (showFeedback && isBlink) {
            setIsBlinkMessage(true)
            setTimeout(() => setIsBlinkMessage(false), 2000)
            return
        }
        if (selected.length === 2) {
            setVerifiedSelection(true)
        } else {
            setVerifiedSelection(false)
        }
    }

    const getDataItems = () => {
        if (isMobileOnly && props.isLandscape) {
            return [0, 2, 4, 6]
        }
        return isMobileOnly ? [0, 4] : [0, 2, 4, 6]
    }

    const getSlicedData = () => {
        if (isMobileOnly && props.isLandscape) {
            return 2
        }
        return isMobileOnly ? 4 : 2
    }

    console.count('Feedback Component')

    return (
        <Container className="container">
            <FeedbackGifs className="feedback-gifs">
                {isSubmitFeedbackScreen ? (
                    <FeedbackForm
                        className="feedback-form"
                        selectedGifs={selectedGifs}
                        setSubmitFeedbackScreen={() =>
                            toggleSubmitFeedbackScreen()
                        }
                        submitFeedback={feedback =>
                            props.onSubmitFeedback(feedback)
                        }
                        feedbackQuestion={
                            props.feedbackQuestion.feedback_question
                        }
                        isFeedbackSubmitted={props.isFeedbackSubmitted}
                        roomName={roomName}
                    />
                ) : (
                    <FeedbackGifWrapper className="feedback-gif-wrapper">
                        <MasonaryWrapper className="masonary-wrapper">
                            <TextCenter color="#fff">
                                <Heading showFeedback={showFeedback}>
                                    {props.feedbackQuestion.question_text}
                                </Heading>
                                <NextButton
                                    active={verifiedSelection}
                                    onClick={() =>
                                        verifiedSelection &&
                                        toggleSubmitFeedbackScreen()
                                    }
                                >
                                    <NextButtonImage
                                        src={chevronRight}
                                    ></NextButtonImage>
                                </NextButton>
                                {showFeedback && (
                                    <Message isBlinkMessage={isBlinkMessage}>
                                        {feedbackMessage}
                                    </Message>
                                )}
                            </TextCenter>
                            <GifSection>
                                {getDataItems().map(i => (
                                    <GifColumn key={i}>
                                        {props.feedbackQuestion?.gifs
                                            ?.filter(item => item.response)
                                            ?.slice(i, i + getSlicedData())
                                            .map(item => (
                                                <GifBox key={item.id}>
                                                    <FeedbackGif
                                                        gif={item}
                                                        addGif={() =>
                                                            addGif(item)
                                                        }
                                                        selectedGifs={
                                                            selectedGifs
                                                        }
                                                        key={item.id}
                                                    />
                                                </GifBox>
                                            ))}
                                    </GifColumn>
                                ))}
                            </GifSection>
                        </MasonaryWrapper>
                    </FeedbackGifWrapper>
                )}
            </FeedbackGifs>
        </Container>
    )
}

const mapStateToProps = state => {
    return {
        feedbackQuestion: state.feedback.feedbackQuestion,
        isFeedbackSubmitted: state.feedback.isFeedbackSubmitted,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetFeedbackQuestion: roomName =>
            dispatch(thunks.getFeedbackQuestion(roomName)),
        onSubmitFeedback: feedback => dispatch(thunks.submitFeedback(feedback)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackNew)
